import * as ContactConstants from "../constants/ContactForm";

const initialState = {
  isOpen: false,
  isSending: false,
  error_message: null,
  eventId: null
};

export function contact(state = initialState, action) {
  switch (action.type) {
    case ContactConstants.SET_OPEN:
      return Object.assign({}, state, {isOpen: action.open});
    case ContactConstants.SET_ERROR:
      return Object.assign({}, state, {error_message: action.error_message, eventId: action.eventId});
    case ContactConstants.SEND_CONTACTFORM_STARTED:
      return Object.assign({}, state, {isSending: true});
    case ContactConstants.SEND_CONTACTFORM_COMPLETED:
      return Object.assign({}, state, {isSending: false, isOpen: false});
    case ContactConstants.SEND_CONTACTFORM_FAILED:
      return Object.assign({}, state, {isSending: false});
    default:
      return state;
  }
}
